module.exports = __webpack_public_path__ + "static/driveway - 1-862053ac5399c83eeb093fe27ff77d64.jpg";